/**
 * The app and the admin panel are one bundle served on two hostnames. These
 * helpers keep the "which am I" logic in one place.
 */

export function isPanelHost(): boolean {
  return window.location.hostname.startsWith('respiriapanel');
}

/**
 * Origin of the main app. From the panel host it's the same domain with
 * `respiriapanel` swapped for `respiria`; anywhere else it's the current
 * origin (dev, or the app itself).
 */
export function mainAppOrigin(): string {
  const { protocol, hostname, port, origin } = window.location;
  if (!isPanelHost()) return origin;
  const host = hostname.replace(/^respiriapanel/, 'respiria');
  return `${protocol}//${host}${port ? `:${port}` : ''}`;
}
